import {useState} from 'react'
import ActionLink from './ActionLink'
import styles from './DevSticker.module.scss'

export default () => {
  const [visible, setVisible] = useState(!!process.env.DEV_STICKER);
  return visible ? (
    <ActionLink className={styles.sticker} onClick={() => setVisible(false)} title="Click to hide">{process.env.DEV_STICKER}</ActionLink>
  ) : null;
}
